import { call, put, takeEvery } from "redux-saga/effects";
import { fetchCoupons, fetchCouponUsers } from "../../api/couponApi";
import { COUPON_CONSTANTS } from "../constants/couponConstants";

function* fetchCouponsSaga(action) {
  try {
    const response = yield call(fetchCoupons, action.payload);
    yield put({ type: COUPON_CONSTANTS.FETCH_COUPONS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: COUPON_CONSTANTS.FETCH_COUPONS_FAILURE, payload: error.message });
  }
}

function* fetchCouponUsersSaga(action) {
  try {
    const response = yield call(fetchCouponUsers, action.payload);
    yield put({ type: COUPON_CONSTANTS.FETCH_COUPON_USERS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: COUPON_CONSTANTS.FETCH_COUPON_USERS_FAILURE, payload: error.message });
  }
}

function* couponSaga() {
  yield takeEvery(COUPON_CONSTANTS.FETCH_COUPONS_REQUEST, fetchCouponsSaga);
  yield takeEvery(COUPON_CONSTANTS.FETCH_COUPON_USERS_REQUEST, fetchCouponUsersSaga);
}

export default couponSaga;